import { render, staticRenderFns } from "./RfxVendorInviteModal.vue?vue&type=template&id=68c3f631"
import script from "./RfxVendorInviteModal.vue?vue&type=script&lang=js"
export * from "./RfxVendorInviteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports